import { type ReactNode } from 'react';
import styled from 'styled-components';

export const WalletHeader = ({ children }: { children: ReactNode }) => {
	return <S.Wrapper>{children}</S.Wrapper>;
};

namespace S {
	export const Wrapper = styled.div`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	`;
}
